import { map, filter } from 'rxjs/operators';

import { BATCH_SEARCH_REQUEST_GET_REJECT } from '../batch-search/batch-search.actions';

import { NOTIFICATION_SHOW_START, showNotification } from './notification.actions';
import { getToastTemplate } from './notification.templates';

const ignoredActionTypes = [NOTIFICATION_SHOW_START, BATCH_SEARCH_REQUEST_GET_REJECT];

export function createNotificationEpic(action$) {
  return action$.pipe(
    filter(action => !ignoredActionTypes.includes(action.type)),
    map(action => getToastTemplate(action)),
    filter(Boolean),
    map(toast => showNotification(toast))
  );
}
